import {AxiosRequestConfig} from 'axios';
import request from '../../axios';

const getStoreSaleAgentList = async ({store_guid}: {store_guid?: string}) => {
  const {data}: {data: IStoreSaleAgentsData[]} = await request.get(
    'api/v2/store/store-agents-list',
    {params: {store_guid}} as AxiosRequestConfig,
  );
  return data;
};

export default getStoreSaleAgentList;
